<template>
    <section ref="slide" class="homewrapper">
       <div class="startlogo">
          <div><span class="name">THO<br>MAS<br>HAA<br><span class="last">F</span></span><slot/></div>
       </div>
   </section>
</template>

<script>
import {
  gsap, TimelineMax, Power4, TweenMax, Power2, Back,
} from 'gsap/dist/gsap';
import helper from '../helper';

export default {
  mounted() {
    if (!helper.isMobile()) {
      const tl = new TimelineMax();
      tl.fromTo('.reddot', 1, { scale: 300 }, { scale: 1, ease: Power2.easeOut }, '+=0.25');
    }
    //helper.popUpNote();
  },
};
</script>

<style lang="scss">
  @import '@/assets/scss/app.scss';
  .homewrapper{
    position: relative;
  }
  .startlogo{
    display: flex;
    flex-direction: column;
    height: 100vh;

    justify-content: center;
    align-items: center;
    overflow: hidden;

    span {
        font-family: 'SourceCodePro Bold';
        font-size: 9vw;
        color: $logo;
        margin: 0;
        padding: 0;
        line-height: 0.85;

        @include breakpoint('m'){
          font-size:11vw;
        }
        @include breakpoint('s'){
          font-size:15vw;
        }
         @include breakpoint('xs'){
          font-size:20vw;
        }

        .last{
          margin-left:-7px;
        }
    }
  }

  .darkmode {
    .startlogo {
      span {
        color: $logo_dark;
      }
    }
  }
</style>
